import AxiosInstance from "./AxiosInstance.js";
import { useState, useEffect } from "react";

import AxiosFileSender from "../lib/AxiosFileSender.js";
import useAPIList from "./useAPIList.js";

export function asArticle(tag) {
  return {
    id: tag.id,
    title: tag.name,
  };
}

export function useTypeTags(type) {
  const [tags, setTags] = useState([]);
  useEffect(() => {
    fetchTypeTag(type).then(setTags).catch(console.error);
  }, [type]);

  return tags;
}

export function useAllTypeTags(type) {
  const [tags, setTags] = useState([]);

  useEffect(() => {
    fetchTypeTag(type, true).then(tags => setTags(Object.values(tags).flat())).catch(console.error)
  }, [type]);

  return tags;
}

export function fetchTypeTag(type, showAll=false) {
  return AxiosInstance.get(`/api/tags`, { params: { type, showAll } }).then((res) => {
    return res.data;
  });
}

export function useTags(type) {
  return useAPIList("/api/tags", { params: { type } });
}

export function deleteTag(id) {
  return AxiosInstance.delete(`/api/tags/${id}`).then((res) => res.data);
}

export function addTag(body) {
  return AxiosFileSender.post("/api/tags", body).then((res) => res.data);
}

export function fetchTag(id) {
  return AxiosInstance.get(`/api/tags/${id}`).then((res) => res.data);
}

export function updateTag(id, body) {
  return AxiosFileSender.put(`/api/tags/${id}`, body).then((res) => res.data);
}
